"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestoreObjectOutput = {
    type: "structure",
    required: [],
    members: {
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        },
        RestoreOutputPath: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-restore-output-path"
        }
    }
};
//# sourceMappingURL=RestoreObjectOutput.js.map